import styled from 'styled-components';
import Tab from '@material-ui/core/Tab';

export const PlayerTab: typeof Tab = styled(Tab)`
  min-width: 0;
  max-width: min-content;
  line-height: 1.25;
  text-transform: none;
  font-size: 0.825rem;
  font-weight: normal;
  padding: 6px 12px;
  transition: background-color;
  transition-duration: 0.7s;

  @media (max-width: 1200px) {
    font-size: 0.775rem;
    padding: 6px 8px;
  }
  @media (max-width: 1040px) {
    font-size: 0.725rem;
    padding: 6px 7px;
  }
  @media (max-width: 930px) {
    font-size: 0.7rem;
    padding: 6px 5px;
  }
  @media (max-width: 845px) {
    font-size: 0.675rem;
    padding: 6px 4px;
  }

  &.Mui-selected {
    background-color: rgba(255, 0, 0, 0.55);
  }
`;
